// Copy for a refused sign-in, keyed by the `reason` the proxy returns from
// GET /my-permissions. One place for the wording so both login paths
// (Microsoft / password) say the same thing for the same situation.
//
//   tenant_not_onboarded — signed in with a Microsoft account from an organization
//                          EcoPrism doesn't know: they need sales/support, not their admin
//   not_provisioned      — the organization is on EcoPrism but this person was never
//                          added: their EcoPrism administrator can fix it
//   no_org               — a password account with no organization behind it
//                          (deprovisioned, or never set up)
export const LOGIN_REASONS = Object.freeze({
  TENANT_NOT_ONBOARDED: "tenant_not_onboarded",
  NOT_PROVISIONED: "not_provisioned",
  NO_ORG: "no_org",
  ORG_INACTIVE: "org_inactive",
});

export const GENERIC_REFUSAL =
  "Your account isn't set up on EcoPrism yet. Ask your EcoPrism administrator to add you, or contact support.";

export function refusalMessage(reason, { supportEmail = "support@ecoprism.com" } = {}) {
  switch (reason) {
    case LOGIN_REASONS.TENANT_NOT_ONBOARDED:
      return `Your organization isn't set up on EcoPrism yet. Contact ${supportEmail} to get started or begin a trial.`;
    case LOGIN_REASONS.NOT_PROVISIONED:
      return `Your organization uses EcoPrism, but your account hasn't been added. Ask your EcoPrism administrator to add you under Settings → User Management, or contact ${supportEmail} if your organization hasn't started yet.`;
    case LOGIN_REASONS.NO_ORG:
      return `This account isn't linked to an organization on EcoPrism. Contact ${supportEmail} to get set up.`;
    case LOGIN_REASONS.ORG_INACTIVE:
      return `Your organization has been deactivated on EcoPrism. Contact ${supportEmail} to reactivate it.`;
    default:
      return GENERIC_REFUSAL;
  }
}

// True when the /my-permissions answer says this person may enter the app.
export function mayEnter(perms) {
  if (!perms || typeof perms !== "object") return false;
  if (perms.staff === true) return true;
  if (perms.reason === LOGIN_REASONS.ORG_INACTIVE) return false;
  return Array.isArray(perms.roles) && perms.roles.length > 0;
}
